import { module } from 'modujs';
import Swiper, { Pagination } from "swiper";
import { queryClosestParent } from '../utils/html';

export default class extends module {
    constructor(m) {
        super(m);

        this.$links = this.el.querySelectorAll('[data-index]')
        this.$wrapper = this.$('wrapper')[0]
        this.$section = queryClosestParent(this.el, '.js-carousel-section');

        this.onFocusBind = this.onFocus.bind(this)
    }

    init() {
        Swiper.use([Pagination])

        this.carousel = new Swiper(this.$('carousel')[0], {
            grabCursor: true,
            slidesPerView: 1.2,
            spaceBetween: 18,
            threshold: 3,
            breakpoints: {
                1000: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 18,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true
                    }
                },
                700: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 18,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true
                    }
                }
            }
        })

        this.bindEvents()
    }

    destroy() {
        super.destroy()
        this.carousel.destroy(true,true)
        this.unbindEvents()
    }

    bindEvents() {
        for (let index = 0; index < this.$links.length; index++) {
            const $link = this.$links[index];
            $link.addEventListener('focus', this.onFocusBind)
        }
    }

    unbindEvents() {
        for (let index = 0; index < this.$links.length; index++) {
            const $link = this.$links[index];
            $link.removeEventListener('focus', this.onFocusBind)
        }
    }

    onFocus(e) {
        const index = e.target.dataset.index
        this.$section.scrollLeft = 0
        this.carousel.slideTo(index)
    }
}
